// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"antd-pro-containers-masters-faculty-add-styles-checkbox"};